var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass].join(' '),attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 24"}},[_c('path',{attrs:{"d":"M19.31 13.15L2.05 23.82a1.37 1.37 0 01-1.87-.51 1.4 1.4 0 01-.18-.64V1.33A1.37 1.37 0 011.4 0a1.47 1.47 0 01.65.18l17.26 10.67a1.3 1.3 0 01.54 1.76 1.34 1.34 0 01-.54.54z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }